<template>
  <BContainer
    fluid
    class="mb-4"
  >
    <div
      class="card card-body border p-3 rounded-lg mt-2 right-ticket-image"
    >
      <div class="h3">
        Good {{ greetings }}, <b class="text-primary">{{ currentUser?.name || 'Officer' }}</b>
      </div>
      <div>
        Your performance summary this month
      </div>
    </div>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import createDate from 'moment'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

export default {

  name: 'VMKODashboard',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: ['auth', 'mkm'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      borderRight: !this.isMobile(),
      requests: {
        pending: 0,
        processing: 0,
        disapproved: 0,
        canceled: 0,
        closed: 0,
        draft: 0
      },
      approvals: {
        pending: 0,
        disapproved: 0,
        approved: 0
      },
      posting: {
        pending: 0,
        unposted: 0,
        posted: 0
      },
      receiving: {
        pending: 0,
        processed: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  },

  methods: {
  }
}
</script>
